import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../shared/Locator';
import { Icon, icons } from '../../../generic';

import styles from './Header.module.less';

type Props = {
  /**
   * Snippet.id, which is parsed in this component to determine the package name & version
   */
  snippetLocator: string;
  /**
   * Count of the number of paths matching this snippet found.
   */
  pathsCount: number;
};

/**
 * The top header section for the SnippetsDrawer
 */
const SnippetsDrawerHeader: VoidFunctionComponent<Props> = ({ snippetLocator, pathsCount }) => {
  const locator = Locator.parse(snippetLocator);
  return (
    <header>
      <div className={styles.headerRow}>
        <span className={styles.icon}>
          <Icon icon={icons.receipt} />
        </span>
        <span className={styles.packageName}>
          {locator.package}
        </span>
        <span className={styles.version}>
          {locator.revision}
        </span>
      </div>
      <div className={styles.snippetsCount}>
        {pathsCount} snippets match to this package
      </div>
    </header>
  );
};

export default SnippetsDrawerHeader;
